import Axios from 'axios';
import TemplateType from '@/entities/TemplateType.js';
import InvalidPayload from '@/exceptions/InvalidPayload.js';
import axios from '../plugins/axios.js';

export default {
    /**
     * @param {number | string} accountId
     * @param {string | null} type
     * @returns {Promise<any[]>}
     */
    async index(accountId, type = null) {
        if (!accountId) {
            throw new InvalidPayload('Account ID not provided.');
        }

        const params = {};

        if (type) {
            if (!TemplateType.exists(type)) {
                throw new InvalidPayload('Invalid template type.');
            }

            params.type = type;
        }

        try {
            const response = await axios.get(`v1/accounts/${accountId}/templates`, {
                once: 'account-templates',
                params,
            });

            return response.data.data;
        } catch (error) {
            if (Axios.isCancel(error)) {
                return [];
            }

            throw error;
        }
    },

    async show(id, payload) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/templates/${id}`, { params: payload });

        return response.data.data;
    },

    async parse(id, locale, leadId) {
        if (!id) {
            throw new InvalidPayload('Template ID not provided.');
        }

        if (!leadId) {
            throw new InvalidPayload('Lead ID not provided.');
        }

        const response = await axios.get(`v1/templates/parse/${id}`, {
            params: { locale, leadId },
        });

        return response.data.data;
    },
};
